import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { categories } from "@/mocks/site";
import { getCollections } from "@/lib/content";

export default function CategoryStrip() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20" aria-labelledby="home-category-title">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          eyebrow="CATEGORY"
          title="按分类直接进，不用在时间线里翻找"
          desc="五个分类各有侧重：花絮看过程、路透看现场、侧拍看光线、彩蛋看呼应、候场看节奏。每个分类下都是同一主题的独立合集。"
          linkTo="/collections"
          linkLabel="查看全部合集"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
          {categories.map((cat, index) => {
            const count = getCollections(cat.slug).length;
            const span =
              index < 2 ? "lg:col-span-3" : "lg:col-span-2";
            return (
              <Link
                key={cat.slug}
                to={`/collections?cat=${cat.slug}`}
                className={`group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-secondary-400 transition-colors ${span}`}
              >
                <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-200">
                  <img
                    src={cat.image}
                    alt={`${cat.name} 分类配图`}
                    title={`${cat.name} 私拍吃瓜合集`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                  <div className="absolute bottom-3 left-4 right-4 flex items-center justify-between">
                    <span className="flex items-center gap-2 text-background-50">
                      <span className="w-8 h-8 rounded-md bg-secondary-500 flex items-center justify-center">
                        <i className={cat.icon} aria-hidden="true" />
                      </span>
                      <span className="font-heading text-lg font-bold">{cat.name}</span>
                    </span>
                    <span className="text-xs text-background-100 px-2 py-1 rounded-md bg-background-50/20">
                      {count} 篇合集
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <p className="text-xs tracking-widest text-primary-600 mb-2">
                    {cat.subtitle}
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {cat.desc}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}